<div class="home-container">
  <div class="map-container">
    <app-map></app-map>

  </div>
</div>
